import { render } from "./vcurriculumlist.vue?vue&type=template&id=b5e03b00&scoped=true"
import script from "./vcurriculumlist.vue?vue&type=script&lang=js"
export * from "./vcurriculumlist.vue?vue&type=script&lang=js"

import "./vcurriculumlist.vue?vue&type=style&index=0&id=b5e03b00&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e03b00"]])

export default __exports__